import {WebSizeProperty} from "../Managers/WebSizeProperty/WebSizeProperty";
import {TypesProperty} from "../Managers/TypesProperty/TypesProperty";
import { AIQueryProperty } from "Core/GeneralProperties/Managers/AIQueryProperty/AIQueryProperty";

export let PropertyManagers = {
	CheckboxProperty: "CheckboxProperty",
	InputTextProperty: "InputTextProperty",
	InputNumberProperty: "InputNumberProperty",
	ColorPicker: "ColorPicker",
	SelectProperty: "SelectProperty",
	SelectEntityTypeProperty: "SelectEntityTypeProperty",
	SelectLockedLinkEntityProperty: "SelectLockedLinkEntityProperty",
	MultiSelectProperty: "MultiSelectProperty",
	InputUrlProperty: "InputUrlProperty",
	FileUploadProperty: "FileUploadProperty",
	QueryConditionProperty: "QueryConditionProperty",
	QueryBuilderProperty: "QueryBuilderProperty",
	AlternativeEntitiesProperty: "AlternativeEntitiesProperty",
	RelationsToCopyProperty: "RelationsToCopyProperty",
	TypesProperty: "TypesProperty",
	BackLinkingProperty: "BackLinkingProperty",
	QuerySortProperty: "QuerySortProperty",
	QuerySelectorProperty: "QuerySelectorProperty",
	ConsultScreenLayout: 'ConsultScreenLayout',
	TabSecurity: 'TabSecurity',
	DimensionalTable: 'DimensionalTable',
	CardScreenProperty: 'CardScreenProperty',
	WebSizeProperty: 'WebSizeProperty',
    DWPackageProperty: 'DWPackageProperty',
	TemplateTypeProperty: 'TemplateTypeProperty',
	DocumentTemplateProperty: 'DocumentTemplateProperty',
	SubFlowProperty: 'SubFlowProperty',
	ExampleAppointmentProperty: 'ExampleAppointmentProperty',
	ConfigurationsSortingProperty: 'ConfigurationsSortingProperty',
	AIQueryProperty: 'AIQueryProperty',
	GridLayoutProperty: 'GridLayoutProperty',
	HyperlinkFieldsProperty: 'HyperlinkFieldsProperty'
};